import { markNotificationAsRead } from "@/data/slices/notificationsSlice";
import { executeToolCommand } from "@/lib/tools/toolCommands";

export const executeNotificationAction = (notification) => (dispatch) => {
  const action = notification?.action;
  if (!action) return;

  if (action.kind === "toolCommand") {
    dispatch(
      executeToolCommand({
        tool: action.tool,
        command: action.command,
        relatedEntities: notification.relatedEntities,
        metadata: notification.metadata,
      }),
    );
  }

  if (!notification.readAtUtc) {
    dispatch(markNotificationAsRead(notification.id));
  }
};
